export enum RuleErrorCodes {
  "RULE_SHIPPING_ROUTE_NOT_FOUND" = "RULE_SHIPPING_ROUTE_NOT_FOUND",
}
